import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import { ClipboardService } from '../../clipboard.service'
import * as models from '../../models'

const COMPONENT_SOURCE = 'Dialog.Clipboard'

@ngCore.Component({
  imports: [
    ngCommon.NgClass,
    ds.layout.widget.Component,
    ds.input.checkbox.Component,
    ds.overlay.attached.Component,
  ],
  selector: 'atn-clipboard-overlay',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * @internal
   * @see {@link ClipboardService}
   */
  public readonly cb = ngCore.inject(ClipboardService)

  /**
   * Dispatch an action which should close Clipboard overlay component
   */
  public closeClipboardOverlayHandler(source: string): void {
    this.cb._feature.actions.closeDialog
      .from(`${COMPONENT_SOURCE}.${source}.Clicked`)
      .dispatch()
  }

  /** Change item selection */
  public handleItemSelectionChange(
    identifiable: models.Item.Identified,
    isSelected: boolean,
  ): void {
    this.cb._feature.actions[isSelected ? 'addSelection' : 'removeSelection']
      .from(`${COMPONENT_SOURCE}.${identifiable.item.getName()}.Clicked`)
      .dispatch({ id: identifiable.id })
  }

  /** Change selection of all items */
  public handleAllItemsSelectionChange(): void {
    // TODO: finish implementation
    throw new Error('Not implemented')
  }

  /** Paste selected items */
  public pasteSelectedItems(): void {
    this.cb._feature.actions.pasteSelected
      .from(`${COMPONENT_SOURCE}.Header.Buttons.Paste.Clicked`)
      .dispatch()
  }

  /** Delete selected items */
  public deleteSelectedItems(): void {
    this.cb._feature.actions.remove
      .from(`${COMPONENT_SOURCE}.Header.Buttons.Delete.Clicked`)
      .dispatch({ selected: true })
  }
}
